import axios from 'axios'
import store from '@/store'
import router from '@/router'

axios.defaults.baseURL = process.env.VUE_APP_API_URL

axios.interceptors.request.use(
    async (config) => {
        const useAuth = config.hasOwnProperty('useAuth') ? config.useAuth : true 
        if (useAuth && store.state.auth.token.length) {
            config.headers['Authorization'] = `Bearer ${ store.state.auth.token }`
        }
        return config
    }, 
    error => Promise.reject(error)
)

let requestsToRefresh = []
let isRefreshRequesting = false

const forceLogoutAndRedirect = () => {
    store.commit('auth/logout', null, { root: true })
    router.push('/login').catch(() => {})
}

const redirectToMaintenance = () => {
    const maintenanceUrl = '/maintenance/index.html'

    if (window.location.pathname === maintenanceUrl) return

    window.location.replace(maintenanceUrl)
}

const isMaintenanceResponse = response =>
    response.status === 503 && (
        response.headers?.['x-sft-maintenance'] === 'true' ||
        response.data?.maintenance === true
    )

axios.interceptors.response.use(null, async err => {
    const { response, config } = err

    if (!response) return Promise.reject(err)

    if (isMaintenanceResponse(response)) {
        redirectToMaintenance()
        return Promise.reject(response)
    }

    if (response.status === 401) {
        const authErrorCode = response.data?.code || ''
        if (['USER_INACTIVE', 'SESSION_INVALID'].includes(authErrorCode)) {
            requestsToRefresh.forEach(cb => cb(null))
            requestsToRefresh = []
            isRefreshRequesting = false
            forceLogoutAndRedirect()
            return Promise.reject(response)
        }

        if (!store.state.auth.token) return Promise.reject(response)
        if (isRefreshRequesting && config.url.includes('/auth/token/refresh')) return Promise.reject(response)

        if (!isRefreshRequesting) {
            isRefreshRequesting = true

            //console.log('Request for a new token')

            store.dispatch('auth/refreshToken').then(() => {
                //console.log('New token received')
                requestsToRefresh.forEach(cb => cb(store.state.auth.token))
            }).catch(e => {
                // Clear token and redirect
                forceLogoutAndRedirect()
                requestsToRefresh.forEach(cb => cb(null))
            }).finally(() =>  {
                //console.log('Clear queue of failed requests')
                requestsToRefresh = []
                isRefreshRequesting = false
            })
        }

        //console.log(`The request is waiting for a new token... [${config.url}]`)
        return new Promise((resolve, reject) => {
            const cfg = { ...config }
            requestsToRefresh.push(token => {
                //console.log(`The request is run with new token... [${cfg.url}]`)
                if (token) {
                    cfg.headers['Authorization'] = `Bearer ${ token }`
                    resolve(axios(cfg))
                }

                reject(response)
            })
        })
    }

    return Promise.reject(response)
})
